import useStoreSelector from "common/redux/useStoreSelector";
import { useQueryString } from "common/useQueryString";
import { FeatureFlagCollection } from "features/featureFlags/featureFlags";

export default function useFeatureFlag(flag: keyof FeatureFlagCollection): boolean {

    const queryString = useQueryString();
    const isEnabled = useStoreSelector(store => store.featureFlags && store.featureFlags[flag].currentValue);

    const queryEnabledKeys = queryString.get("enableFlags");

    return isEnabled || (queryEnabledKeys && queryEnabledKeys.includes(flag));
}